export default "__VITE_ASSET__3cc72870__"